import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rValue } from '../../models/.catalog';
import rYurtDisiTasinmazlariBilgi from '../../models/rYurtDisiTasinmazlariBilgi';

export default class YurtDisiTasinmazlariBilgiApi extends ApiBase<
  pList,
  rValue<rYurtDisiTasinmazlariBilgi>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/YurtDisiTasinmazlariBilgi',
      }),
      options
    );
  }
}
